import { alias, deserialize, identifier, serializable } from "serializr";
import { IJsonObject } from "../api";

interface IProps {
	id?: number | null;
	firstName?: string;
	lastName?: string;
	email?: string;
	phone?: string;
	UTMSource?: string;
	company?: string;
	title?: string;
	phoneOther?: string;
	employees?: number;
	street?: string;
	city?: string;
	state?: string;
	postalCode?: string;
	country?: string;
}

export class Lead {
	public static fromJson(json: IJsonObject): Lead {
		return deserialize(Lead, json);
	}

	public static fromJsonArray(json: IJsonObject[]): Lead[] {
		return json.map((lead: IJsonObject) => this.fromJson(lead));
	}

	@serializable(identifier())
	public id: number | null;

	@serializable(alias("firstname"))
	public firstName: string;

	@serializable(alias("lastname"))
	public lastName: string;

	@serializable
	public email: string;

	@serializable
	public phone: string;

	@serializable
	public UTMSource: string;

	@serializable
	public company: string;

	@serializable
	public title: string;

	@serializable
	public phoneOther: string;

	@serializable
	public employees: number;

	@serializable
	public street: string;

	@serializable
	public city: string;

	@serializable
	public state: string;

	@serializable
	public postalCode: string;

	@serializable
	public country: string;

	get fullName() {
		return this.firstName + " " + this.lastName;
	}

	constructor({
		id = null,
		firstName = "",
		lastName = "",
		email = "",
		phone = "",
		UTMSource = "",
		company = "",
		title = "",
		phoneOther = "",
		employees = 0,
		street = "",
		city = "",
		state = "",
		postalCode = "",
		country = "",
	}: IProps = {}) {
		this.id = id;
		this.firstName = firstName;
		this.lastName = lastName;
		this.email = email;
		this.phone = phone;
		this.UTMSource = UTMSource;
		this.company = company;
		this.title = title;
		this.phoneOther = phoneOther;
		this.employees = employees;
		this.street = street;
		this.city = city;
		this.state = state;
		this.postalCode = postalCode;
		this.country = country;
	}
}
